var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarEnv = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 0.666992V2.00033H9.00065V0.666992H10.334V2.00033H13.0007C13.3689 2.00033 13.6673 2.29881 13.6673 2.66699V13.3337C13.6673 13.7019 13.3689 14.0003 13.0007 14.0003H1.00065C0.632464 14.0003 0.333984 13.7019 0.333984 13.3337V2.66699C0.333984 2.29881 0.632464 2.00033 1.00065 2.00033H3.66732V0.666992H5.00065ZM12.334 7.33366H1.66732V12.667H12.334V7.33366ZM3.66732 3.33366H1.66732V6.00033H12.334V3.33366H10.334V4.66699H9.00065V3.33366H5.00065V4.66699H3.66732V3.33366Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarEnv, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarEnv.3caa89d9.svg";
export { ForwardRef as ReactComponent };